/**
 * UIConfig
 *
 * @deprecated Topic-scoped configs have moved to `src/shared/config/`:
 *   - chat-bubble.config.ts  (chat bubble appearance + timing)
 *   - display.config.ts       (NPC text offset, map name Y)
 *
 * This file is now a thin backwards-compat shim re-exporting the legacy
 * `UI_CONFIG.DISPLAY` shape from the new typed config so existing
 * consumers (`GAME_CONSTANTS.UI.NPC_TEXT_OFFSET_Y` callers, GameConstants
 * proxy) keep working without edits. Migrate per-file at your leisure.
 */

import { DISPLAY } from '../config/display.config';

export const UI_CONFIG = {
  DISPLAY: {
    MAP_NAME_Y: DISPLAY.mapNameY,
    NPC_TEXT_OFFSET_Y: DISPLAY.npcTextOffsetY,
  },
};
